import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Heading4 } from '@/components/ui/typography'
import { RadioButton } from '@progress/kendo-react-inputs'
import { FormBaseButtonContainer, FormBaseColumn } from 'components/Form/Form.styles'
import { FormFieldGroup } from 'routes/Transactions/Transactions.styles'

import { SubscriptionTimeInForce } from './SubscriptionTimeInForce'

interface Props {
  onClose(): void
  onConfirm(): void
  onChange(optionId: number): void
  isDowngrade?: boolean
  isUnsubscribe?: boolean
}

export const SubscriptionTimeInForceForm: React.FC<Props> = ({
  onClose,
  onConfirm,
  onChange,
  isDowngrade,
  isUnsubscribe,
}) => {
  const [selectedOptionId, setSelectedOptionId] = useState(0)
  return (
    <>
      <Heading4>
        {isUnsubscribe
          ? 'When would you like the unsubscription to be processed?'
          : 'When would you like the subscription to start?'}
      </Heading4>
      {(isUnsubscribe ? unsubscriptionTypeOptions : subscriptionTypeOptions).map((option) => {
        return (
          <FormBaseColumn style={{ marginTop: '1.5rem' }}>
            <FormFieldGroup>
              <RadioButton
                value={option.id}
                label={option.displayName}
                onChange={() => {
                  setSelectedOptionId(option.id)
                  onChange(option.id)
                }}
                checked={option.id === selectedOptionId}
                disabled={option.id === SubscriptionTimeInForce.Immediate && isDowngrade}
              />
            </FormFieldGroup>
          </FormBaseColumn>
        )
      })}
      <FormBaseButtonContainer
        style={{ justifyContent: 'flex-end', marginTop: '2rem', gap: '1rem' }}
      >
        <Button key='button' type='button' disabled={selectedOptionId < 1} onClick={onConfirm}>
          Submit
        </Button>
        <Button key='button' type='button' onClick={onClose}>
          Cancel
        </Button>
      </FormBaseButtonContainer>
    </>
  )
}

export interface SubscriptionTypeOption {
  id: SubscriptionTimeInForce
  displayName: string
}
export const subscriptionTypeOptions: SubscriptionTypeOption[] = [
  {
    id: SubscriptionTimeInForce.Immediate,
    displayName: 'Today',
  },
  {
    id: SubscriptionTimeInForce.BeginningOfNextMonth,
    displayName: 'First day of next month',
  },
]

export const unsubscriptionTypeOptions: SubscriptionTypeOption[] = [
  {
    id: SubscriptionTimeInForce.Immediate,
    displayName: 'Immediately',
  },
  {
    id: SubscriptionTimeInForce.BeginningOfNextMonth,
    displayName: 'End of month',
  },
]
